// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4566":"2f19de06","4779":"1692fbd6","6830":"1692fbd6"}[chunkId] + ".chunk.css";
};